<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row
          v-if="unidades.length > 1"
          dense
        >
          <v-toolbar flat>
            <v-toolbar-title>
              <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
                FILTROS
              </h2>
            </v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete
              v-model="unidadesSelecionadas"
              :item-text="getUnidadeSiglaAndNome"
              :items="unidades"
              :search-input.sync="searchUnidade"
              class="mx-2"
              label="Unidade(s):"
              placeholder="Digite para pesquisar..."
              multiple
              prepend-icon="account_balance"
              return-object
              @change="searchUnidade = ''"
            >
              <template
                v-if="unidades.length > 0"
                v-slot:prepend-item
              >
                <v-list-item @click="toggleItens">
                  <v-list-item-action>
                    <v-icon
                      :color="unidadesSelecionadas.length > 0 ? 'primary' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Selecionar Todas</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
              <template v-slot:selection="data">
                <v-chip
                  :input-value="data.selected"
                  class="chip--select-multi"
                  close
                  color="primary"
                  search=""
                  small
                  text-color="white"
                  @click:close="removeUnidade(data.item)"
                >
                  {{ data.item.sigla }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="filtroSituacao"
              :items="situacoes"
              class="ml-2"
              label="Situação:"
              prepend-icon="filter_list"
            />
          </v-col>
          <v-spacer class="hidden-sm-and-down" />
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="search"
              append-icon="search"
              class="mx-4"
              hide-details
              label="Pesquisar"
              single-line
            />
          </v-col>
        </v-row>
        <v-row>
          <v-toolbar flat>
            <v-toolbar-title>
              <h2 class="title primary--text text--darken-1 text-no-wrap ma-2">
                COMPETÊNCIAS TÉCNICAS ({{ competencias.length }})
              </h2>
            </v-toolbar-title>
          </v-toolbar>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          v-model="competenciasSelecionadas"
          :headers="headers"
          :items="competencias"
          :search="search"
          class="elevation-0"
          item-key="id"
          show-expand
          show-select
          single-expand
        >
          <template v-slot:[`item.nomeAtual`]="{ item }">
            <p
              :class="
                item.unidades.length > 0 ? 'grey-text' : 'secondary--text'
              "
            >
              {{ item.nomeAtual }}
            </p>
          </template>
          <!-- select all -->
          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox
              v-show="
                competencias.length > 0 &&
                  (etapa === 'normalizacao' || etapa === 'consolidacao') &&
                  prazoAtual
              "
              :disabled="filtroSituacao === 'Competências Gerais'"
              color="primary"
              v-bind="props"
              @input="toggleAllCheckboxes"
              v-on="on"
            />
          </template>
          <!-- select current -->
          <template
            v-slot:[`item.data-table-select`]="{ isSelected, select, item }"
          >
            <v-simple-checkbox
              v-show="
                (etapa === 'normalizacao' || etapa === 'consolidacao') &&
                  prazoAtual
              "
              v-ripple
              :disabled="item.unidades.length === 0"
              :value="isSelected"
              color="primary"
              @input="select($event)"
            />
          </template>

          <template
            v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  height="100%"
                  text
                  width="100%"
                  @click="expand(!isExpanded)"
                  v-on="on"
                >
                  <v-badge right>
                    <template v-slot:badge>
                      <span>{{ item.responsabilidades.length }}</span>
                    </template>
                    <v-icon
                      color="grey lighten-0"
                      large
                    >
                      settings
                    </v-icon>
                  </v-badge>
                </v-btn>
              </template>
              <span>Clique para exibir as responsabilidades relacionadas</span>
            </v-tooltip>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              class="justify-center"
            >
              <v-row v-if="item.responsabilidades.length > 0">
                <v-spacer />
                <v-col cols="10">
                  <v-simple-table
                    class="elevation-0 mb-4"
                    dense
                  >
                    <template v-slot:default>
                      <thead class="font-weight-medium">
                        <tr>
                          <td>Unidade</td>
                          <td>Responsabilidade</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="responsabilidade in item.responsabilidades"
                          :key="responsabilidade.id"
                        >
                          <td>
                            {{ responsabilidade.unidade.sigla }}
                          </td>
                          <td>
                            {{ responsabilidade.tituloAtual }}
                            <v-chip
                              v-show="responsabilidade.normalizada"
                              class="mx-2"
                              color="secondary"
                              outlined
                              small
                            >
                              Normalizada
                            </v-chip>
                            <v-chip
                              v-show="responsabilidade.validada"
                              class="mr-2"
                              color="purple lighten-2"
                              outlined
                              small
                            >
                              Validada
                            </v-chip>
                            <v-chip
                              v-show="responsabilidade.consolidada"
                              class="mr-2"
                              color="success"
                              outlined
                              small
                            >
                              Consolidada
                            </v-chip>
                            <v-chip
                              v-show="responsabilidade.excluida"
                              class="mb-2"
                              color="error"
                              outlined
                              small
                            >
                              Arquivada
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-spacer />
              </v-row>
              <v-row v-else>
                <v-col>
                  <p class="text-center">
                    Não há responsabilidades vinculadas a está competência.
                  </p>
                </v-col>
              </v-row>
            </td>
          </template>
          <template
            v-if="etapa !== 'validacao'"
            v-slot:[`item.acoes`]="{ item }"
          >
            <v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn
                      v-show="item.unidades.length"
                      class="mr-2"
                      color="secondary"
                      icon
                      small
                      @click="editItem(item)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span
                  v-if="!item.hasResponsabilidadeConsolidada"
                >Clique no botão para editar a competência</span>
                <span
                  v-else
                >Não é permitido editar competências associadas a
                  responsabilidades consolidadas</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn
                      v-show="item.unidades.length"
                      class="mr-2"
                      color="error"
                      icon
                      small
                      @click="confirmDelete(item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span
                  v-if="!item.hasResponsabilidadeConsolidada"
                >Clique no botão para excluir a competência</span>
                <span
                  v-else
                >Não é permitido excluir competências associadas a
                  responsabilidades consolidadas</span>
              </v-tooltip>
            </v-col>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <cadastro-edicao-competencia
      :competencia="competencia"
      :is-edicao="dialogs.save.isEdicao"
      :mapeamento="mapeamento"
      :etapa="etapa"
      :toogle="toogleSave"
      :unidades-selecionadas="unidadesSelecionadas"
      :visibilidade="dialogs.save.visibilidade"
      @hide="toogleSave"
    />

    <dialog-remove
      :confirm-action="deleteItem"
      :descricao="dialogs.remove.descricao"
      :dialog-visible="dialogs.remove.visibilidade"
      :toogle-visible="toogleRemove"
    />
  </div>
</template>

<script>
import CadastroEdicaoCompetencia from '@/components/mapeamento/CadastroEdicaoCompetencia';
import DialogRemove from '@/components/DialogRemove';
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const competenciaTecnicaRepository = RepositoryFactory.get('competenciaTecnica');

export default {
  name: 'GerenciamentoCompetenciasTecnicas',

  components: {
    CadastroEdicaoCompetencia,
    DialogRemove,
  },

  props: {
    unidades: {
      type: Array,
      required: true,
    },
    mapeamento: {
      type: Object,
      required: true,
    },
    etapa: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    prazoAtual: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      unidadesSelecionadas: [],
      competencia: { nome: '', unidades: [] },
      search: '',
      searchUnidade: '',
      dialogs: {
        save: { visibilidade: false, isEdicao: false, item: null },
        remove: { visibilidade: false, item: null },
      },
      headers: [
        { text: 'COMPETÊNCIA', value: 'nomeAtual', sortable: false },
        {
          text: 'RESPONSABILIDADES',
          value: 'data-table-expand',
          width: '15%',
          align: 'center',
        },
        {
          text: '',
          value: 'acoes',
          sortable: false,
          width: '25%',
          align: 'end',
        },
      ],
      situacoes: ['Todas', 'Competências Gerais', 'Competências Inseridas'],
      filtroSituacao: 'Todas',
    };
  },

  computed: {
    ...mapState({
      isComissao: (state) => state.auth.comissao,
    }),
    competenciasSelecionadas: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    competenciasTecnicas: {
      get() {
        return this.$store.state.competencia.competenciasTecnicas;
      },
      set(value) {
        const payload = { tipo: 'TECNICA', competencias: value.sort((a, b) => a.nomeAtual.localeCompare(b.nomeAtual)) };
        this.$store.dispatch('competencia/setCompetencias', payload);
      },
    },
    competencias() {
      if (!this.filtroSituacao && this.unidadesSelecionadas.length === 0) {
        return [];
      }

      return this.competenciasTecnicas
        .filter((c) => c.unidades.length === 0 || (c.mapeamento && c.mapeamento.id === this.mapeamento.id))
        .map((c) => {
          const responsabilidades = this.responsabilidades
            .filter((r) => this.unidadesSelecionadas.some((u) => u.idVersao === r.unidade.id))
            .filter((r) => r.competenciasAtuais && r.competenciasAtuais.some((c2) => c2.id === c.id))
            .sort(
              (a, b) => a.unidade.sigla.localeCompare(b.unidade.sigla) || a.tituloAtual.localeCompare(b.tituloAtual),
            );

          return {
            ...c,
            responsabilidades,
            hasResponsabilidadeValidada: responsabilidades.some((r) => r.validada),
          };
        })
        .filter(
          (c) => (c.unidades.length === 0
              && c.responsabilidades.length > 0
              && this.filtroSituacao !== 'Competências Inseridas')
            || (this.unidadesSelecionadas.some((u) => c.unidades.some((u2) => u2.unidade.id === u.id))
              && (this.filtroSituacao === 'Todas'
                || (this.filtroSituacao === 'Competências Inseridas' && c.unidades.length > 0))),
        )
        .sort((a, b) => a.nomeAtual.localeCompare(b.nomeAtual));
    },
    responsabilidades: {
      get() {
        return this.$store.state.responsabilidade.responsabilidades;
      },
      set(responsabilidades) {
        this.$store.dispatch('responsabilidade/setResponsabilidades', responsabilidades);
      },
    },
    selectAllItens() {
      return this.unidadesSelecionadas.length === this.unidades.length;
    },
    selectSomeItens() {
      return this.unidadesSelecionadas.length > 0 && !this.selectAllItens;
    },
    icon() {
      if (this.selectAllItens) {
        return 'check_box';
      }
      if (this.selectSomeItens) {
        return 'indeterminate_check_box';
      }
      return 'check_box_outline_blank';
    },
  },

  watch: {
    mapeamento() {
      this.unidadesSelecionadas = [];
    },
  },

  created() {
    if (this.unidades.length === 1) {
      this.unidadesSelecionadas.push(this.unidades[0]);
    }
    if (this.mapeamento && this.responsabilidades.length === 0) {
      const payload = { mapeamento: this.mapeamento.id, comissao: this.isComissao };
      this.$store.dispatch('responsabilidade/load', payload);
    }
  },

  methods: {
    toggleAllCheckboxes() {
      if (this.competenciasSelecionadas.length) {
        this.competenciasSelecionadas = [];
      } else {
        this.competenciasSelecionadas = this.competencias.filter((c) => c.unidades.length > 0);
      }
    },
    editItem(item) {
      if (this.isComissao || (this.etapa === 'validacao' && !item.hasResponsabilidadeValidada)) {
        this.competencia = { ...item };
        this.dialogs.save.isEdicao = true;
        this.toogleSave();
      } else {
        this.$store.dispatch('app/error', {
          message:
            'Esta competência não pode ser editada pois está associada a responsabilidade validada.'
            + 'Favor desvalidar antes de realizar a edição.',
        });
      }
    },
    confirmDelete(item) {
      if (this.isComissao || (this.etapa === 'validacao' && !item.hasResponsabilidadeValidada)) {
        this.dialogs.remove.item = item;

        const nResponsabilidades = item.responsabilidades.length;
        this.dialogs.remove.descricao = '';
        if (nResponsabilidades > 0) {
          this.dialogs.remove.descricao = `Esta competência está associada a ${nResponsabilidades} responsabilidade${
            nResponsabilidades > 1 ? 's' : ''
          }.`;
        }
        this.dialogs.remove.descricao += 'Você realmente deseja excluir essa competência?';

        this.toogleRemove();
      } else {
        this.$store.dispatch('app/error', {
          message:
            'Esta competência não pode ser excluída pois está associada a responsabilidade validada. '
            + 'Favor desvalidar antes de realizar a exclusão.',
        });
      }
    },
    deleteItem() {
      if (this.dialogs.remove.item) {
        const competencia = this.dialogs.remove.item;
        competenciaTecnicaRepository.delete(competencia.id, this.unidadesSelecionadas).then(async (res) => {
          this.responsabilidades = this.responsabilidades.map((r) => {
            if (this.unidadesSelecionadas.some((us) => us.idVersao === r.unidade.id)) {
              r.competenciasTecnicas = r.competenciasTecnicas.filter((c) => c.id !== competencia.id);
              r.competenciasTecnicasComissao = r.competenciasTecnicasComissao.filter((c) => c.id !== competencia.id);
              r.competenciasTecnicasChefia = r.competenciasTecnicasChefia.filter((c) => c.id !== competencia.id);
              r.competenciasTecnicasConsolidado = r.competenciasTecnicasConsolidado.filter(
                (c) => c.id !== competencia.id,
              );
              r.competenciasAtuais = r.competenciasAtuais.filter((c) => c.id !== competencia.id);
            }
            return r;
          });

          let msgSucess;
          if (res.data === 'competência deletada') {
            // se a competência foi excluída, removemos ela
            this.competenciasTecnicas = this.competenciasTecnicas.filter((c) => c.id !== competencia.id);
            msgSucess = 'Competência excluída com sucesso!';
          } else if (res.data === 'competência removida das unidades informadas') {
            // se foi apenas removida das responsabilidades associadas às unidades informadas
            // não é necessário fazer atualizar o estado, pois o relacionamento entre competência -> responsabilidades
            // é computed em função das responsabilidades, atualizadas acima
            const unidadesStr = this.unidadesSelecionadas.map((u) => u.sigla).join(', ');
            this.competenciasTecnicas = this.competenciasTecnicas.map((c) => {
              if (c.id === competencia.id) {
                c.unidades = c.unidades.filter((u) => !this.unidadesSelecionadas.some((us) => us.id === u.id));
              }
              return c;
            });
            msgSucess = `Competência removida para as unidades selecionadas (${unidadesStr})!`;
          }

          await this.$store.dispatch('app/success', { response: res, message: msgSucess });
          this.toogleRemove();
        });
      }
    },
    toogleSave() {
      this.dialogs.save.visibilidade = !this.dialogs.save.visibilidade;
      if (!this.dialogs.save.visibilidade) {
        this.competencia.id = null;
        this.competencia.nome = '';
        this.competencia.unidades = [];
        this.dialogs.save.isEdicao = false;
      }
    },
    toogleRemove() {
      this.dialogs.remove.visibilidade = !this.dialogs.remove.visibilidade;
      if (!this.dialogs.remove.visibilidade) {
        this.dialogs.remove.item = null;
      }
    },
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
    removeUnidade(item) {
      const index = this.unidadesSelecionadas.findIndex((u) => u.id === item.id);
      if (index !== -1) {
        this.unidadesSelecionadas.splice(index, 1);
      }
    },
    toggleItens() {
      this.$nextTick(() => {
        if (this.selectAllItens) {
          this.unidadesSelecionadas = [];
        } else {
          this.unidadesSelecionadas = [...this.unidades];
        }
      });
    },
  },
};
</script>
